import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { fireGTM } from '../../gtm/gtmUtil';
import { nextButton_GTM } from '../../gtm/datalayers/utilDataLayers.json';

const nextButtonStyles = {
  color: (props) => ({
    backgroundColor: props.color,
    borderColor: props.color,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.color}`,
      color: props.color,
      borderStyle: 'solid',
    },
  }),
};

class NextButton extends Component {
  constructor(props) {
    super(props);
    this.goToNextPage = this.goToNextPage.bind(this);
  }

  goToNextPage() {
    const { history } = this.props;

    fireGTM(nextButton_GTM, this.props.text, this.props.section);

    if (history) history.push(this.props.nextPath);
  }

  dynamicClass = () => (this.props.isActive ? this.props.classes.color : null);

  render() {
    return (
      <Translation>
        {(t) => (
          <button
            aria-label={this.props.ariaLabel || t('Next Button')}
            className={[
              this.props.overRideStyle,
              this.dynamicClass(),
              'button--primary',
            ].join(' ')}
            disabled={!this.props.isActive}
            // Not all 'Next Buttons' just need to go to another page, some might need you to save info in the redux store
            onClick={
              this.props.onClick === undefined
                ? this.goToNextPage
                : this.props.onClick
            }
            type="button"
            data-cy="desktop-next-button"
          >
            {this.props.overRideButtonText
              ? this.props.overRideButtonText
              : t('Next')}
          </button>
        )}
      </Translation>
    );
  }
}

export default withStyles(nextButtonStyles)(withRouter(NextButton));

NextButton.propTypes = {
  color: PropTypes.string.isRequired,
};
